export enum AppEnv {
  DEVELOPMENT = "development",
  STAGING = "staging",
  PRODUCTION = "production"
}
